import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formatMultiplier, formatOdds, formatPercent } from './utils';

const buildDefaultMeta = (horse) =>
  `単勝 ${formatOdds(horse.odds)} / 勝率 ${formatPercent(horse.winRate, 1)} / 期待値 ${formatMultiplier(horse.expectedValue, 2)}`;

function AiFocusHorses({
  horses,
  eyebrow = 'AI FOCUS',
  title = 'AI注目馬',
}) {
  return (
    <Box className="race-detail-panel race-detail-focus-panel">
      <Typography className="race-detail-section-eyebrow">{eyebrow}</Typography>
      <Typography className="race-detail-section-title">{title}</Typography>

      <Stack spacing={1.5} sx={{ mt: 2.5 }}>
        {horses.map((horse) => (
          <Box
            key={horse.horseNumber}
            className="race-detail-focus-card"
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography className="race-detail-focus-name">
                <span className="race-detail-horse-pill">{horse.horseNumber}</span>
                <span className="race-detail-focus-name-text">{horse.horseName}</span>
                <span className={`race-detail-inline-rank race-detail-rank-${horse.aiRank.toLowerCase()}`}>
                  {horse.aiRank}
                </span>
              </Typography>
              <Typography className="race-detail-focus-meta">{horse.metaText || buildDefaultMeta(horse)}</Typography>
            </Box>
            <Box className={`race-detail-rank-badge race-detail-rank-${horse.aiRank.toLowerCase()}`}>
              {horse.aiRank}
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default AiFocusHorses;
